<template>
  <div v-click-outside="closeSidebar">
    <b-sidebar v-model="isOpened" title="MyFigbMate">
      <div class="tagline"><i>la webapp di WFigb</i></div>
      <b-navbar-nav class="text-left mt-3">
        <template v-for="page in pageList">
          <b-nav-item v-if="canShow(page)" :key="page.textKey" :to="page.to" class="ml-5">
            <b-img height="32px" width="32px" :src="require('../../assets/iconsMenu/' + page.icon + '.png')"></b-img>
            {{ $t(page.textKey) }}
          </b-nav-item>
        </template>
      </b-navbar-nav>
      <b-navbar-nav class="position-fixed text-left" style="bottom: 10px">
        <template v-for="page in pageBottomList">
          <b-nav-item v-if="canShow(page)" :key="page.textKey" :to="page.to" class="ml-5">
            <b-icon :icon="page.icon"></b-icon>
            {{ $t(page.textKey) }}
          </b-nav-item>
        </template>
      </b-navbar-nav>
    </b-sidebar>
    <hamburger-menu v-model="isOpened" :animated="false" class="hamburger"/>
  </div>
</template>

<script>
import HamburgerMenu from './HamburgerMenu';
import {mapGetters} from "vuex";

export default {
  name: 'sidebar',
  components: {HamburgerMenu},
  data() {
    return {
      isOpened: false
    };
  },
  computed: {
    ...mapGetters({
      configurations: 'webApp/configurations',
      contestType: 'tournament/contestType',
      playerCode: 'webApp/playerCode',
      teamRanks: 'ranks/teamRanks',
      pairRanks: 'ranks/pairRanks',
      pairId: 'tournament/pairId',
      butlerRanks: 'ranks/butlerRanks',
      playerCurrentSessionMap: 'players/playerCurrentSessionMap',
      matches: 'matches/matches',
      isTd: 'webApp/isTd',
      isVisitor: 'webApp/isVisitor',
    }),

    pageList() {
      return [
        {
          to: '/',
          icon: 'figb',
          textKey: 'pageLinks.welcome'
        },
        {
          to: 'tablesMap',
          icon: 'tavolo',
          ifEnabled: this.isTd && this.isPairContest,
          textKey: 'pageLinks.tablesMap'
        },
        {
          to: 'directorsMap',
          icon: 'arbitri',
          ifEnabled: this.canShowTdMap,
          textKey: 'pageLinks.directorsMap'
        },
        {
          to: 'sendResult',
          icon: 'inviaris',
          ifEnabled: this.canShowSendResult,
          textKey: 'pageLinks.sendResult'
        },
        {
          to: 'movementGuide',
          icon: 'movim',
          ifEnabled: this.canShowMovementGuide,
          textKey: 'pageLinks.movementGuide'
        },
        {
          to: 'curriculum',
          icon: 'curriculum',
          ifEnabled: this.canShowCurriculum,
          textKey: 'pageLinks.curriculum'
        },
        {
          to: 'scoreViewer',
          icon: 'mostraris',
          ifEnabled: this.isPairContest,
          textKey: 'pageLinks.scoreViewer'
        },
        {
          to: 'teamScoreViewer',
          icon: 'confrscore',
          ifEnabled: !this.isPairContest,
          textKey: 'pageLinks.teamScoreViewer'
        },
        {
          to: 'pairRanks',
          icon: 'classcp',
          ifEnabled: Object.values(this.pairRanks?.Phases ?? {}).length > 0,
          textKey: 'pageLinks.pairRanks'
        },
        {
          to: 'teamRanks',
          icon: 'classsq',
          ifEnabled: this.teamRanks.Phases != null && Object.keys(this.teamRanks.Phases).length > 0,
          textKey: 'pageLinks.teamRanks'
        },
        {
          to: 'butlerRanks',
          icon: 'classbut',
          ifEnabled: this.butlerRanks.Phases != null && Object.keys(this.butlerRanks.Phases).length > 0,
          textKey: 'pageLinks.butlerRanks'
        },
        {
          to: 'matches',
          icon: 'incontri',
          ifEnabled: this.matches.length > 0,
          textKey: 'pageLinks.matches'
        }
      ];
    },
    pageBottomList() {
      return [
        {
          to: '/debug',
          icon: 'bug',
          ifEnabled: this.enableDebug,
          textKey: 'pageLinks.debug'
        }
      ];
    },
    canShowCurriculum() {
      return this.configurations["MostraCurriculum"] && this.isPairContest && this.pairId > 0;
    },
    canShowTdMap() {
      return this.isTd && this.configurations['MostraMappaTd'];
    },
    canShowMovementGuide() {
      return this.isPairContest && this.playerCurrentSessionMap.length > 0;
    },
    canShowSendResult() {
      return !this.isVisitor && this.configurations['AllowSendResults'];
    },
    isPairContest() {
      return this.contestType !== 0;
    },
    enableDebug() {
      return ["BTR110", "DSL092"].includes(this.playerCode);
    },
  },
  methods: {
    toggle() {
      this.isOpened = !this.isOpened;
    },
    closeSidebar() {
      this.isOpened = false;
    },
    canShow(page) {
      if (typeof (page.ifEnabled) === 'function') {
        return page.ifEnabled();
      }
      if (typeof (page.ifEnabled) === 'boolean') {
        return page.ifEnabled;
      }

      return page.ifEnabled == null || this.configurations[page.ifEnabled];
    }
  }
};
</script>

<style scoped>
.hamburger {
  position: fixed;
  left: 1rem;
  top: 1rem;
  background-color: white;
  z-index: 999;
}

>>> .b-sidebar-header strong {
  color: #1B708D;
}

.nav-item.nav-item.nav-item a {
  color: #1B708D;
}

.nav-item.nav-item.nav-item a:hover {
  color: #3396B8;
}

.tagline {
  margin-left: 1rem;
  margin-top: 0;
  position: absolute !important;
  top: 38px;
}

</style>
